// extracted by mini-css-extract-plugin
module.exports = {"actions":"LeaveSessionDialog_actions__3SokU"};